
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import CatalogsService from '@/services/CatalogsService'
import { Device } from '@/types/catalogs/Devices'

@Component({
  name: 'ResetLicenseDeviceModal'
})
export default class ResetLicenseDeviceModal extends Vue {
  @Prop({ required: true })
  devices: Device[]

  @Prop({ required: false, default: false })
  fromAdminLicensesList: boolean

  resetDevicesConfirmation: boolean = false
  deviceClass = Device
  /**
   * Calls the DELETE function for every device on the list
   * that receives as parameter, and display a toast for each promise resolved
   *
   * @param devices to reset (delete)
   */
  async deleteDevices (devices: Device[]) {
    let devicesToReset: Promise<Device>[] = []
    devices.forEach(device => {
      const request = CatalogsService.deleteDeviceById(device.id)
      const licenseResponse = `El dispositivo: ${device.id} - ${device.name} - ${device.uuid}`
      devicesToReset.push(request)
      request
        .then((response) => {
          this.$bvToast.toast(`${licenseResponse} ha sido eliminado.`, {
            title: 'Eliminado correctamente',
            variant: 'success',
            toaster: 'b-toaster-top-right',
            solid: true,
            autoHideDelay: 5000
          })
        })
        .catch((error) => {
          // Manage current and future error format
          let dataError = error.response.data
          let errors = []
          if (dataError.errors) {
            dataError.errors.forEach((e: any) => {
              errors.push(e.description)
            })
          } else {
            errors.push(dataError.description ? dataError.description : error.response)
          }
          this.$bvToast.toast(`${licenseResponse} no se ha podido eliminar. ${errors.join(', ')}`, {
            title: 'Error al eliminar',
            variant: 'danger',
            toaster: 'b-toaster-top-left',
            solid: true,
            autoHideDelay: 5000
          })
        })
    })
    await Promise.allSettled(devicesToReset)
      .finally(() => {
        this.$emit('update-licenses-list', this.fromAdminLicensesList)
        this.$emit('update-devices-list')
      })
    this.closeDeleteDevicesModal()
  }

  /**
   * Hides modal for reset devices
   * and turn off the confirmation flag
   */
  closeDeleteDevicesModal () {
    this.resetDevicesConfirmation = false
    this.$bvModal.hide('delete-devices-licenses-modal')
  }
}
